import { useDispatchTool, useStateTool } from 'app/store/withDevTools';
import React from 'react';
import { ContasPagarInitState, ContasPagarReducer } from './contasPagarReducer';

const ContasPagarContext = React.createContext();
const ContasPagarDispatcher = React.createContext();

const ContasPagarProvider = (props) => {
  const [state, dispatch] = React.useReducer(ContasPagarReducer, ContasPagarInitState);

  return (
    <ContasPagarContext.Provider value={state}>
      <ContasPagarDispatcher.Provider value={dispatch}>{props.children}</ContasPagarDispatcher.Provider>
    </ContasPagarContext.Provider>
  );
};

function ContasPagarConsumer({ children }) {
  return (
    <ContasPagarContext.Consumer>
      {(context) => {
        if (context === undefined) {
          throw new Error('ContasPagarConsumer must be used within a ContasPagarProvider');
        }

        return children(context);
      }}
    </ContasPagarContext.Consumer>
  );
}

function useContasPagar() {
  return [
    useStateTool(ContasPagarContext, 'ContasPagarContext'),
    useDispatchTool(ContasPagarDispatcher, 'ContasPagarDispatcher'),
  ];
}

export { ContasPagarProvider, ContasPagarConsumer, useContasPagar };
